import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient, private system: SystemService) {}

  getFiles(filter: any): Observable<any> {
    let formData: HttpParams = new HttpParams();

    if ( filter.query )
      formData = formData.append('search', filter.query);

    if ( filter.folder )
      formData = formData.append('folder', filter.folder);
    return this.http.get<any[]>(this.system.apiURL + '/documents', {params: formData});
  }

  getFolders(): Observable<any> {
    return this.http.get(`${this.system.apiURL}/documents/folders`);
  }

  saveRecentFile(file: any): Observable<any> {
    return this.http.post(`${this.system.apiURL}/recent-files`, file);
  }

  getRecentFiles(): Observable<any> {
    return this.http.get(`${this.system.apiURL}/recent-files`);
  }

  uploadFile(file: File, source: string, type?: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('source', source);

    if (type)
      formData.append('type', type);

    const req = new HttpRequest('POST', this.system.apiURL + '/documents', formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadPublicFile(file: File, source: string, type?: string): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('source', source);

    if (type)
      formData.append('type', type);

    const req = new HttpRequest('POST', this.system.apiURL + '/public/documents', formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  starFile(id: number): Observable<any> {
    return this.http.post(`${this.system.apiURL}/${id}/star`, {});
  }

  deleteFile(id: number): Observable<any> {
    return this.http.delete(`${this.system.apiURL}/${id}`);
  }

  recoverFile(id: number): Observable<any> {
    return this.http.post(`${this.system.apiURL}/${id}/recover`, {});
  }


}
